// extracted by mini-css-extract-plugin
export default {"container":"style_container__RzsDG","block":"style_block__g1TMh","header":"style_header__hwchV","button":"style_button__x8Cri","input":"style_input__N+ZSa"};